import config from '../config'

export default {
    config: config,
}
const permissions = config.permissions;
const base = config.base_folder
export const menuItems = [
    {
        id: 1,
        label: "Dashboard",
        icon: "bx-home-circle",
        badge: {
            'variant'   :  'danger',
            "text"      :   'order'
        },
        subItems: [
            {
                id: 2,
                label: "General",
                link: base+"dashboard",
                parentId: 1,
                required_permission: permissions.dashboard_read,
                permissions: [permissions.dashboard_read]
            },
            {
                id: 3,
                label: "Ordering",
                link: base+"orders/list",
                parentId: 1,
                required_permission: permissions.order_read,
                permissions: [permissions.order_read,permissions.order_write],
                badge: {
                    'variant'   :  'danger',
                    "text"      :   'order'
                }
            },
            // {
            //     id: 5,
            //     label: "Driver",
            //     link: base+"driver/dashboard",
            //     parentId: 1,
            //     required_permission: permissions.dashboard_driver_read,
            //     permissions: [permissions.dashboard_driver_read]
            // },
            {
                id: 4,
                label: "Eagle View",
                link: base+"eagle-view/list",
                parentId: 1,
                required_permission: permissions.eagle_view_read,
                permissions: [permissions.eagle_view_read]
            } 
        ]
    },
    {
        id: 6,
        label: "Management",
        icon: "bx-user",
        subItems: [
            {
                id: 7,
                label: "Vendors",
                link: base+"vendors",
                parentId: 6,
                required_permission: permissions.merchant_read,
                permissions: [permissions.merchant_read,permissions.merchant_write]
            },
            {
                id: 8,
                label: "Driver",
                link: base+"driver",
                parentId: 6,
                required_permission: permissions.driver_read,
                permissions: [permissions.driver_read,permissions.driver_write]
            },
            {
                id: 9,
                label: "Customer",
                link: base+"customer",
                parentId: 6,
                required_permission: permissions.customer_read,
                permissions: [permissions.customer_read,permissions.customer_write]
            },
            // {
            //     id: 100,
            //     label: "Credit",
            //     link: base+"customer-credit",
            //     parentId: 6,
            //     required_permission: permissions.customer_read,
            //     permissions: [permissions.customer_read,permissions.customer_write]
            // },
            {
                id: 32,
                label: "Product",
                link: base+"product",
                parentId: 6,
                required_permission: permissions.customer_read,
                permissions: [permissions.customer_read,permissions.customer_write]
            },
            {
                id: 35,
                label: "TimeSlot",
                link: base+"time-slot",
                parentId: 6,
                required_permission: permissions.customer_read,
                permissions: [permissions.customer_read,permissions.customer_write]
            },

            {
                id: 36,
                label: "Alert",
                link: base+"alert",
                parentId: 6,
                required_permission: permissions.customer_read,
                permissions: [permissions.customer_read,permissions.customer_write]
            }, 

            {
                id: 37,
                label: "Deals",
                link: base+"deal",
                parentId: 6,
                required_permission: permissions.customer_read,
                permissions: [permissions.customer_read,permissions.customer_write]
            },
            {
                id: 38,
                label: "Supplier",
                link: base+"supplier",
                parentId: 6,
                required_permission: permissions.customer_read,
                permissions: [permissions.customer_read,permissions.customer_write],
                subItems: [
                    {
                        id: 39,
                        label: "Supplier",
                        link: base+"supplier",
                        parentId: 38,
                        required_permission: permissions.supplier_details_read,
                        permissions: [permissions.supplier_details_read, permissions.supplier_details_write]
                    },
                    {
                        id: 39,
                        label: "Purchasing Prices",
                        link: base+"supplier/purchasing_price_list",
                        parentId: 38,
                        required_permission: permissions.customer_read,
                        permissions: [permissions.customer_read,permissions.customer_write],
                    },
                ],
            },
            {
                id: 39,
                label: "Contact",
                link: base+"contact",
                parentId: 6,
                required_permission: permissions.customer_read,
                permissions: [permissions.customer_read,permissions.customer_write]
            }
        ]
    },
    {
        id: 14,
        label: "Locations",
        icon: "bx-map",
        subItems: [
            {
                id: 15,
                label: "Location",
                link: base+"location",
                parentId: 14,
                required_permission: permissions.location_read,
                permissions: [permissions.location_read,permissions.location_write]
            },
            {
                id: 16,
                label: "Delivery Zones",
                link: base+"delivery_zone",
                parentId: 14,
                required_permission: permissions.delivery_zone_read,
                permissions: [permissions.delivery_zone_read,permissions.delivery_zone_write]
            },
            {
                id: 17,
                label: "Postal Codes",
                link: base+"postal_codes",
                parentId: 14,
                required_permission: permissions.postal_codes_read,
                permissions: [permissions.postal_codes_read,permissions.postal_codes_write]
            },
            // {
            //     id: 17,
            //     label: "Delivery Zones",
            //     link: base+"delivery_zone",
            //     parentId: 14,
            //     required_permission: permissions.delivery_zone_read,
            //     permissions: [permissions.delivery_zone_read,permissions.delivery_zone_write]
            // }
        ]
    },
    {
        id: 29,
        label: "Promotions",
        icon: "bx-purchase-tag",
        subItems: [
            {
                id: 30,
                label: "Promocode",
                link: base+"coupon",
                parentId: 29,
                required_permission: permissions.promo_code_read,
                permissions: [permissions.promo_code_read,permissions.promo_code_write]
            },
            {
                id: 31,
                label: "Banners",
                link: base+"banner",
                parentId: 29,
                required_permission: permissions.banner_read,
                permissions: [permissions.banner_read,permissions.banner_write]
            }
        ]
    },
    {
        id: 10,
        label: "Financial Reports",
        icon: "bx-file",//bx-rupee
        subItems: [
            {
                id: 11,
                label: "Vendors",
                link: base+"finance/vendor",
                parentId: 10,
                required_permission: permissions.vendor_finance_read,
                permissions: [permissions.vendor_finance_read,permissions.vendor_finance_write]
            },
            // {
            //     id: 12,
            //     label: "Drivers",
            //     link: base+"finance/driver",
            //     parentId: 10,
            //     required_permission: permissions.driver_finance_read,
            //     permissions: [permissions.driver_finance_read,permissions.driver_finance_write]
            // },
            {
                id: 13,
                label: "Reports",
                link: base+"reports",
                parentId: 10,
                required_permission: permissions.reports_read,
                permissions: [permissions.reports_read,permissions.reports_write]
            },
        ]
    },   
    {
        id: 17,
        label: "Contents",
        icon: "bx-home-circle",
        subItems: [
            {
                id: 18,
                label: "Business Category",
                link: base+"category",
                parentId: 17,
                required_permission: permissions.category_read,
                permissions: [permissions.category_read,permissions.category_write]

            },
            {
                id: 19,
                label: "Product Brand",
                link: base+"product-brand",
                parentId: 17,
                required_permission: permissions.brand_read,
                permissions: [permissions.brand_read,permissions.brand_write]
            },
            {
                id: 38,
                label: "Producer Company",
                link: base+"producer-company",
                parentId: 17,
                required_permission: permissions.brand_read,
                permissions: [permissions.brand_read,permissions.brand_write]
            },
            {
                id: 20,
                label: "Pages",
                link: base+"content-page",
                parentId: 17,
                required_permission: permissions.content_pages_read,
                permissions: [permissions.content_pages_read,permissions.content_pages_write]
            },
            {
                id: 34,
                label: "FAQ Categories",
                link: base+"faq-category",
                parentId: 17,
                required_permission: permissions.faq_category_read,
                permissions: [permissions.faq_category_,permissions.faq_category_write]
            },
            {
                id: 21,
                label: "FAQ",
                link: base+"faq",
                parentId: 17,
                required_permission: permissions.faq_read,
                permissions: [permissions.faq_read,permissions.faq_write]
            },
            {
                id: 36,
                label: "Attribute",
                link: base+"attribute",
                parentId: 17,
                required_permission: permissions.attribute_read,
                permissions: [permissions.attribute_read,permissions.attribute_write]
            },
            {
                id: 37,
                label: "Popular Search",
                link: base+"popular-search",
                parentId: 17,
                required_permission: permissions.popular_search_read,
                permissions: [permissions.popular_search_read,permissions.popular_search_write]
            },
        ]
    },

    {
        id: 18,
        label: "Invoices",
        icon: "bx-file",
        subItems: [
            {
                id: 16,
                label: "Invoice",
                link: base+"invoice/list",
                parentId: 18,
                required_permission: permissions.location_read,
                permissions: [permissions.location_read,permissions.location_write]
            },
        ]
    },
    {
        id: 24,
        label: "Settings",
        icon: "bx-laptop",
        subItems: [
            {
                id: 25,
                label: "Configurations",
                link: base+"settings/configurations",
                parentId: 24,
                required_permission: permissions.configuration_read,
                permissions: [permissions.configuration_read,permissions.configuration_write]
            },
            // {
            //     id: 26,
            //     label: "App Layout Settings",
            //     link: base+"settings/app-layout-setting",
            //     parentId: 24,
            //     required_permission: permissions.layout_read,
            //     permissions: [permissions.layout_read,permissions.layout_write]
            // },
            {
                id: 27,
                label: "User & Access",
                link: base+"settings/user-access",
                parentId: 24,
                required_permission: permissions.user_access_read,
                permissions: [permissions.user_access_read,permissions.user_access_write]

            },
            {
                id: 28,
                label: "Terminology",
                link: base+"settings/terminology",
                parentId: 24,
                required_permission: permissions.terminology_read,
                permissions: [permissions.terminology_read,permissions.terminology_write]
            },
           
        ]
    },
    {
        id: 22,
        label: "Others",
        icon: "bx-file",
        subItems: [
            {
                id: 23,
                label: "Logs",
                link: base+"system/list",
                parentId: 22,
                required_permission: permissions.logs_read,
                permissions: [permissions.logs_read,permissions.logs_write]
            },
            {
                id: 24,
                label: "Csv Logs",
                link: base+"csv/logs",
                parentId: 22,
                required_permission: permissions.csv_logs_read,
                permissions: [permissions.csv_logs_read,permissions.csv_logs_write]
            }
        ]
    }
];
